import React, { useState, useEffect } from 'react';
import './index.css';

import Navbar from './components/Navbar';
import Hero from './components/Hero';
import ServicesBanner from './components/ServicesBanner';
import WhyChooseUs from './components/WhyChooseUs';
import OurServices from './components/OurServices';
import AIInnovation from './components/AIInnovation';
import Process from './components/Process';
import OperationalExcellence from './components/OperationalExcellence';
import CTA from './components/CTA';
import Footer from './components/Footer';
import LoadingScreen from './components/LoadingScreen';
import { ModalProvider } from './context/ModalContext';
import ContactModal from './components/ContactModal';

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Show loading screen for 3.5 seconds to showcase animation
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 3500);
    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return <LoadingScreen />;
  }

  return (
    <ModalProvider>
      <div className="App animate-fade-in">
        <Navbar />
        <Hero />
        <ServicesBanner />
        <WhyChooseUs />
        <OurServices />
        <AIInnovation />
        <Process />
        <OperationalExcellence />
        <CTA />
        <Footer />
      </div>
      <ContactModal />
    </ModalProvider>
  );
}

export default App;
